import { SecondHandRequestComponent } from './../../components/second-hand-request/second-hand-request.component';
import { SelectionModel } from '@angular/cdk/collections';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { BehaviorSubject } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { Filter } from 'src/app/core/models/filter';
import { LoginData } from 'src/app/core/models/login-data';
import { LoginService } from 'src/app/core/services/login.service';
import { ToastService } from 'src/app/core/toast.service';
import { CancelOrderComponent } from '../../components/cancel-order/cancel-order.component';
import { GetSecondHandSuppliesOrdersService } from '../../services/get-second-hand-supplies-orders.service';
import { GetSecondHandSuppliersService } from '../../services/get-second-hand-supplier';
import { trigger, state, style, transition, animate } from '@angular/animations';
import { SecondHandSuppliesOrders } from 'src/app/modules/dashboard/modules/pre-owned-orders/models/second-hand-supplies-orders';

@Component({
  selector: 'app-my-pre-owned-orders',
  templateUrl: './my-pre-owned-orders.component.html',
  styleUrls: ['./my-pre-owned-orders.component.scss'],
  animations: [
    trigger("openCloseStatus", [
      state('true', style({ height: '*', opacity: '1' })),
      state('false', style({ height: '160px', opacity: '1' })),
      transition("false <=> true", [animate(500)])
    ])
  ],
})
export class MyPreOwnedOrdersComponent implements OnInit {
  columnList = [
    {
      column: "sku",
      title: "Sku",
      operators: [
        { title: "Contains", operator: "_ilike" },
      ],
      type: "text",
    }
  ];
  operatorList = [];
  filterForm = this.fb.group({
    status: [null],
    supplier_name:[null],
    start: [null],
    end: [null],
    limit: [10, [Validators.required]],
    filters: this.fb.array([this.getField()]),
    offset: [0, [Validators.required]]
  });
  totalElements = 0;
  filterSubject: BehaviorSubject<Filter> = new BehaviorSubject<Filter>(this.filterForm.value);
  /* --------------------------------- FIELDS -------------------------------- */
  // FILTER-FUNCTIONALITIES
  OpenFilter = false;
  openStatus = false;
  displayedColumns: string[] = ['select', 'sNo', 'orderId', 'customerName', 'total_amount', 'contactNumber', 'payment_status', 'action'];
  secondHandSuppliesOrdersList: SecondHandSuppliesOrders[];
  statusWiseCount: any;
  selection = new SelectionModel<SecondHandSuppliesOrders>(true, []);
  loginData: LoginData;
  secondHandSuppliersList: any[];
  /* ------------------------------- Constructor ------------------------------ */
  constructor(
    private dialog: MatDialog,
    private fb: FormBuilder,
    private getSecondHandSuppliesOrdersService: GetSecondHandSuppliesOrdersService,
    private toast: ToastService,
    private getSecondHandSuppliersService :GetSecondHandSuppliersService,
    private loginService: LoginService
  ) {
    this.loginData = this.loginService.getLoginData();
  }
  /* ----------------------------- NG-LIFE-CYCLES ----------------------------- */
  ngOnInit(): void {
    this.filterSubject.pipe(switchMap(filter => {
      this.secondHandSuppliesOrdersList = null;
      return this.getSecondHandSuppliesOrdersService.getSecondHandSuppliesOrders(filter);
    })).subscribe(([second_hand_supplies_orders, count]: [SecondHandSuppliesOrders[], number]) => {
      this.secondHandSuppliesOrdersList = second_hand_supplies_orders;
      this.totalElements = count;
    });
    this.getSecondHandSuppliersService.getSecondHandSuppliers().subscribe(data=>{
      this.secondHandSuppliersList = data;
      //alert(data);

      console.log(this.secondHandSuppliersList);

    })
  }
  /* ------------------------------ CUSTOM-METHODS ----------------------------- */

  filterToggle(): void {
    this.OpenFilter = !this.OpenFilter;
  }
  filterToggleStatus(): void {
    this.openStatus = !this.openStatus;
    // if(this.openStatus && this.filters.length === 0){
    //   this.plusField();
    // }
  }
  setStatus() {
    this.filterSubject.next(this.filterForm.value);
  }
  plusField() {
    console.log("hello");
    this.filters.push(this.getField());
  }
  minusField(i: number) {
    this.filters.removeAt(i);
  }
  getField() {
    return this.fb.group({
      column: [null, [Validators.required]],
      operator: [null, [Validators.required]],
      value: [null, [Validators.required]]
    })
  }
  filterChange() {
    this.filterSubject.next(this.filterForm.value);
  }
  searchProductByName() {
    this.filterSubject.next(this.filterForm.value);
  }
 
  /* --------------------------------- Getters -------------------------------- */
  cancelOrder(supplyOrder: any) {
    const dialogRef = this.dialog.open(CancelOrderComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: supplyOrder
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
        this.filterSubject.next(this.filterForm.value);
      }
    })
  }
  supportRequestDialog(supplyOrder: any) {
    const dialogRef = this.dialog.open(SecondHandRequestComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      data: supplyOrder
    });
    dialogRef.afterClosed().subscribe(data => {
      if (data === 'yes') {
      }
    })
  }
  /* ------------------------------- FilterForm ------------------------------- */
  get start() {
    return this.filterForm.get('start');
  }
  get end() {
    return this.filterForm.get('end');
  }
  get status(): AbstractControl {
    return this.filterForm.get("status");
  }
  get supplier_name(): AbstractControl {    
    return this.filterForm.get("supplier_name");
  }
  get limit(): AbstractControl {
    return this.filterForm.get('limit');
  }
  get offset(): AbstractControl {
    return this.filterForm.get('offset');
  }
  get filters(): FormArray {
    return this.filterForm.get('filters') as FormArray;
  }
  changePage(e: PageEvent) {
    this.offset.setValue(e.pageSize * e.pageIndex);
    this.filterSubject.next(this.filterForm.value);
  }
  setDateFilter(){
    if(this.start.value && this.end.value){
      this.filterSubject.next(this.filterForm.value);
    }
  }
  clear(){
    this.start.reset(null);
    this.end.reset(null);
    this.filterSubject.next(this.filterForm.value);
  }

  clearFilters(){
    this.start.setValue(null),
    this.end.setValue(null);
    this.status.setValue(null);
    this.supplier_name.setValue(null);
    this.filterSubject.next(this.filterForm.value);
  }

  showClearButton(){
    return this.status.value || this.supplier_name.value || this.start.value || this.end.value;
  }
  viewInvoice(order: any){
    window.open(`https://dental-360.herokuapp.com/api/v1/event/get-secondhand-invoice/${order.id}`);
  }
}

